// Machine-draft translations of seven accessibility labels that were missing
// from every non-English locale. No professional/native-speaker sign-off is
// implied. Existing reviewed locale JSON and live professional overrides WIN.
const KEYS = Object.freeze([
  ['common', 'uniformIcon.professionalClothing'],
  ['common', 'uniformIcon.paramedicUniform'],
  ['common', 'trustHomeLinkAria'],
  ['compare', 'removeRoleAria'],
  ['compare', 'roleFallback'],
  ['feedback', 'rateOutOfFiveAria'],
  ['find', 'compareSelectedRolesAria'],
]);
const DRAFTS = Object.freeze({
  "ar": [
    "الملابس المهنية",
    "زي المسعف",
    "اعرف رعايتك، {{hospital}}. الصفحة الرئيسية",
    "إزالة {{role}} من المقارنة",
    "دور",
    "قيّم {{rating}} من 5",
    "مقارنة {{count}} من الأدوار المحددة"
  ],
  "bn": [
    "পেশাগত পোশাক",
    "প্যারামেডিকের ইউনিফর্ম",
    "নো ইয়োর কেয়ার, {{hospital}}। হোম",
    "তুলনা থেকে {{role}} সরান",
    "ভূমিকা",
    "৫-এর মধ্যে {{rating}} রেটিং দিন",
    "নির্বাচিত {{count}}টি ভূমিকা তুলনা করুন"
  ],
  "es": [
    "Ropa profesional",
    "Uniforme de personal paramédico",
    "Know Your Care, {{hospital}}. Inicio",
    "Quitar {{role}} de la comparación",
    "función",
    "Valorar con {{rating}} de 5",
    "Comparar {{count}} funciones seleccionadas"
  ],
  "fa": [
    "پوشش حرفه‌ای",
    "لباس فرم امدادگر اورژانس",
    "مراقبت خود را بشناسید، {{hospital}}. صفحه اصلی",
    "حذف {{role}} از مقایسه",
    "نقش",
    "امتیاز {{rating}} از ۵ را انتخاب کنید",
    "مقایسه {{count}} نقش انتخاب‌شده"
  ],
  "fr": [
    "Tenue professionnelle",
    "Tenue de personnel paramédical",
    "Know Your Care, {{hospital}}. Accueil",
    "Retirer {{role}} de la comparaison",
    "rôle",
    "Attribuer une note de {{rating}} sur 5",
    "Comparer les {{count}} rôles sélectionnés"
  ],
  "gu": [
    "વ્યાવસાયિક પોશાક",
    "પેરામેડિકનો યુનિફોર્મ",
    "નો યોર કેર, {{hospital}}. મુખ્ય પાનું",
    "સરખામણીમાંથી {{role}} દૂર કરો",
    "ભૂમિકા",
    "5 માંથી {{rating}} રેટિંગ આપો",
    "પસંદ કરેલી {{count}} ભૂમિકાઓની સરખામણી કરો"
  ],
  "it": [
    "Abbigliamento professionale",
    "Uniforme del personale paramedico",
    "Know Your Care, {{hospital}}. Pagina iniziale",
    "Rimuovi {{role}} dal confronto",
    "ruolo",
    "Assegna {{rating}} stelle su 5",
    "Confronta {{count}} ruoli selezionati"
  ],
  "pa": [
    "ਪੇਸ਼ੇਵਰ ਪਹਿਰਾਵਾ",
    "ਪੈਰਾਮੈਡਿਕ ਦੀ ਵਰਦੀ",
    "ਨੋ ਯੋਰ ਕੇਅਰ, {{hospital}}। ਮੁੱਖ ਪੰਨਾ",
    "ਤੁਲਨਾ ਵਿੱਚੋਂ {{role}} ਹਟਾਓ",
    "ਭੂਮਿਕਾ",
    "5 ਵਿੱਚੋਂ {{rating}} ਦੀ ਰੇਟਿੰਗ ਦਿਓ",
    "ਚੁਣੀਆਂ ਗਈਆਂ {{count}} ਭੂਮਿਕਾਵਾਂ ਦੀ ਤੁਲਨਾ ਕਰੋ"
  ],
  "pl": [
    "Odzież zawodowa",
    "Mundur ratownika medycznego",
    "Know Your Care, {{hospital}}. Strona główna",
    "Usuń {{role}} z porównania",
    "rola",
    "Oceń na {{rating}} z 5",
    "Porównaj {{count}} wybranych ról"
  ],
  "pt": [
    "Vestuário profissional",
    "Uniforme de paramédico",
    "Know Your Care, {{hospital}}. Página inicial",
    "Remover {{role}} da comparação",
    "função",
    "Atribuir {{rating}} em 5",
    "Comparar {{count}} funções selecionadas"
  ],
  "ro": [
    "Îmbrăcăminte profesională",
    "Uniforma personalului paramedical",
    "Know Your Care, {{hospital}}. Acasă",
    "Elimină {{role}} din comparație",
    "rol",
    "Acordă nota {{rating}} din 5",
    "Compară {{count}} roluri selectate"
  ],
  "so": [
    "Dharka shaqada",
    "Dirayska shaqaalaha gurmadka caafimaadka",
    "Know Your Care, {{hospital}}. Bogga hore",
    "Ka saar {{role}} isbarbardhigga",
    "door",
    "Sii qiimeyn {{rating}} ka mid ah 5",
    "Isbarbar dhig {{count}} door oo la doortay"
  ],
  "tl": [
    "Propesyonal na kasuotan",
    "Uniporme ng paramedic",
    "Know Your Care, {{hospital}}. Pangunahing pahina",
    "Alisin ang {{role}} sa paghahambing",
    "tungkulin",
    "Bigyan ng {{rating}} sa 5 na rating",
    "Ihambing ang {{count}} napiling tungkulin"
  ],
  "tr": [
    "Profesyonel kıyafet",
    "Paramedik üniforması",
    "Know Your Care, {{hospital}}. Ana sayfa",
    "{{role}} rolünü karşılaştırmadan kaldır",
    "rol",
    "5 üzerinden {{rating}} puan ver",
    "Seçilen {{count}} rolü karşılaştır"
  ],
  "ur": [
    "پیشہ ورانہ لباس",
    "پیرامیڈک کی وردی",
    "اپنی نگہداشت کو جانیں، {{hospital}}۔ ہوم",
    "{{role}} کو موازنے سے ہٹائیں",
    "کردار",
    "5 میں سے {{rating}} کی درجہ بندی دیں",
    "منتخب کردہ {{count}} کرداروں کا موازنہ کریں"
  ],
  "zh": [
    "专业工作服",
    "急救医护人员制服",
    "Know Your Care，{{hospital}}。首页",
    "从比较中移除{{role}}",
    "角色",
    "评分：{{rating}}分（满分5分）",
    "比较已选择的{{count}}个角色"
  ]
});

const languageId = lng => String(lng || '').toLowerCase().split('-')[0];
export function accessibilityDraftFor(locale, namespace, path) {
  const values = DRAFTS[languageId(locale)];
  if (!values) return undefined;
  const index = KEYS.findIndex(([ns, key]) => ns === namespace && key === path);
  return index < 0 ? undefined : values[index];
}
export function installAccessibilityDraftTranslations(i18n, language, namespace) {
  const lang = languageId(language);
  if (!DRAFTS[lang]) return;
  KEYS.forEach(([ns, path], index) => {
    if (ns !== namespace) return;
    // addResource (default overwrite) is only called for a truly absent/empty
    // locale key. Never supersede existing locale or professional corrections.
    const current = i18n.getResource(lang, ns, path);
    if (typeof current !== 'string' || !current.trim())
      i18n.addResource(lang, ns, path, DRAFTS[lang][index]);
  });
}
export const ACCESSIBILITY_DRAFT_LOCALES = Object.freeze(Object.keys(DRAFTS).sort());
export const ACCESSIBILITY_DRAFT_KEYS = KEYS;
